import React, { useContext, useState } from 'react';
import SvgIcon from '../../../../common/components/svg-icon';
import { DataContext } from "../withData";
import EditorCell1 from "./EditorCell1";
import EditorCell2 from "./EditorCell2";
import EditorCell3 from "./EditorCell3";

const Level1Line = ({ tagObj, isOpen, setIsOpen, modalInfo }) => {
  const { deleteTag, updateTag } = useContext(DataContext);
  const [ saving, setSaving ] = useState(false);
  const [ editing, setEditing ] = useState(false);
  const [ tempText, setTempText ] = useState(tagObj.label);

  const handleDelete = () => {
    if (!window.confirm(`Do you really want to delete "${tagObj.tag}" tag?`)) {
      return;
    }
    setSaving(true);
    deleteTag('express_category', tagObj.value, () => {});
  };

  const handleSave = () => {
    setSaving(true);
    updateTag('express_category', tagObj.value, tempText, () => {
      setSaving(false);
      setEditing(false);
    });
  };

  const enableEditing = () => {
    setEditing(true);
    setTempText(tagObj.label);
  };

  const cancelEditing = () => {
    setEditing(false);
  };

  return (
    <div className="form_grid -v-middle -js-level1">
      <div className="form_grid-item">
        {isOpen && <SvgIcon name="i-squared-minus" className="-v-middle -pointer" onClick={ () => { setIsOpen(false); } } />}
        {!isOpen && <SvgIcon name="i-squared-plus"  className="-v-middle -pointer" onClick={ () => { setIsOpen(true); } } />}
      </div>
      <div className="form_grid-item -grow">
        <EditorCell1
          value={ tagObj.label }
          editing={ editing }
          saving={ saving }
          tempText={ tempText }
          setTempText={ setTempText }
          handleSave={ handleSave }
        />
      </div>
      <div className="form_grid-item">
        <EditorCell2
          modalInfo={ modalInfo }
          count={ tagObj.count }
          editing={ editing }
          saving={ saving }
          cancelEditing={ cancelEditing }
        />
      </div>
      <div className="form_grid-item">
        <EditorCell3
          editing={ editing }
          enableEditing={ enableEditing }
          tempText={ tempText }
          count={ tagObj.count }
          saving={ saving }
          handleDelete={ handleDelete }
          handleSave={ handleSave }
        />
      </div>
    </div>
  );
};

export default Level1Line;
